/**
 * Created by 1 on 2016/12/12.
 */
/**
 * @deprecated
 * Module控件的基类
 */
'use strict';
define([
    './ComponentBase',
    './BeanManagable',
    '../utils/ResourceUtil',
    '../utils/CommonUtil',
],function(
    ComponentBase,
    BeanManagable,
    ResourceUtil,
    CommonUtil
){
    /**
     * 构造方法
     * @ignore
     * @constructor
     * @classdesc 模块基类
     * @alias G.base.ModuleBase
     * @augments G.base.ComponentBase
     * @param {Object} options - 必填，构造参数对象
     * @param {G.Map} options.map - 必填，地图对象
     * @param {String} options.staticPath - 可选，公共资源路径
     * @param {String} options.resourcePath - 可选，模块包目录如./modules/DemoModule/；
     * 如果设置，则cssPath/configPath/htmlPath/imgPath的默认相对目录为此值；
     * 默认为工程里的固定目录。
     * @param {String} options.cssPath - 可选，样式目录，默认为控件包下的css目录
     * @param {String} options.configPath - 可选，配置文件目录，默认为控件包下的config目录
     * @param {String} options.imgPath - 可选，图片目录，默认为控件包下的img目录
     * @param {String} options.htmlPath - 可选，静态html目录，默认为控件包下的html目录
     * @param {String} options.config - 可选，配置文件名，其目录相对options.configPath
     * @returns {Class} 实例化对象
     */
    var module=ComponentBase.extend({
        //默认配置项
        options:{
            //公共静态资源路径
            staticPath:'',
            //样式目录
            cssPath:'',
            //配置文件目录
            configPath:'',
            //图片目录
            imgPath:'',
            //静态html目录
            htmlPath:'',
            //模块资源目录如./modules/DemoModule/
            resourcePath:''
        },
        //类型标识
        TYPE:"Module",
        initialize:function(options){
            ComponentBase.prototype.initialize.call(this, options);
        },
        /**
         * 打开视图
         * @method
         * @memberOf G.base.ModuleBase.prototype
         */
        onOpen : function() {},
        /**
         * 关闭视图
         * @method
         * @memberOf G.base.ModuleBase.prototype
         */
        onClose : function() {},
        /**
         * 销毁，对应initialize
         * @method
         * @memberOf G.base.ModuleBase.prototype
         */
        destroy:function(){
            this.onClose();
        },
        /**
         * 获取模块的资源路径
         * @method
         * @memberOf G.base.ModuleBase.prototype
         * @returns {String}
         */
        getResourcePath:function(){
            if(!this._resourcePath){
                var name=this.options.name||'Anonymous';
                if(!name.endsWith('Module')){
                    name+='Module';
                }
                this._resourcePath=ResourceUtil.getModulePath(name);
            }
            return this._resourcePath;
        },
        /**
         * 设置模块的资源路径
         * @method
         * @memberOf G.base.ModuleBase.prototype
         * @returns {String}
         */
        setResourcePath:function(path){
            if(path){
                //处理多余的斜杠
                this._resourcePath=(path+'').replace(/([\/\\]+)/g,'/');
                if(!this._resourcePath.endsWith('/')){
                    this._resourcePath=this._resourcePath+'/';
                }
            }else{
                this._resourcePath=null;
            }
        }

    });
    //
    BeanManagable.enable(module);
    return module;
})
